import React, { useState } from 'react';
import Card from '../../components/Card/Card';
import ErrorMessageNewFund from '../../components/ErrorMessages/ErrorMessageNewFund';
import ErrorMessageNoData from '../../components/ErrorMessages/ErrorMessageNoData';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';
// import { shouldDisplayNewFundMessage } from '../../utils/fund-info';
import { CARD_NAMES } from '../../utils/constants';
import styles from './GeographicalExposureChart.css';
import {
    GEOGRAPHICAL_EXPOSURE_QUERY,
    ETF_GEOGRAPHICAL_EXPOSURE_QUERY
} from './queries';
import {
    geographicalExposureChartCardUtil,
    geographicalExposureChartCardUtilETF
} from './util';

const GeographicalExposureChart = ({ ticker, etf }) => {
    const [filter] = useState([]);

    return (
        <div className="section-container">
            <Card>
                <GqlQueryWrapper
                    filter={filter}
                    query={
                        etf
                            ? ETF_GEOGRAPHICAL_EXPOSURE_QUERY
                            : GEOGRAPHICAL_EXPOSURE_QUERY
                    }
                    variables={{ ticker }}
                    dataFunc={
                        etf
                            ? geographicalExposureChartCardUtilETF
                            : geographicalExposureChartCardUtil
                    }
                    placeholder={() => <TablePreRender />}
                >
                    {({
                        data: {
                            data: chunkedData,
                            asOfDate,
                            hasValues,
                            isGeoCardNew
                        }
                    }) => {
                        // Check if data for the card is missing
                        if (!(chunkedData.length && hasValues && asOfDate)) {
                            // Check if the fund is new, where new is less than 40 days since inception
                            if (isGeoCardNew) {
                                return (
                                    <ErrorMessageNewFund
                                        cardName={
                                            CARD_NAMES.GEOGRAPHICAL_EXPOSURE
                                        }
                                    />
                                );
                            }
                            return (
                                <ErrorMessageNoData
                                    cardName={CARD_NAMES.GEOGRAPHICAL_EXPOSURE}
                                />
                            );
                        }

                        return (
                            <React.Fragment>
                                <div>
                                    <TitleWithDescription title="Geographical Exposure" />
                                    <div className="geo-card-subheader">
                                        Top 10 countries as a percentage of
                                        total net assets
                                    </div>
                                </div>

                                <div className="tables">
                                    {chunkedData.map(({ data }, index) => (
                                        <div
                                            key={
                                                data && data.name
                                                    ? `geo-column-${data.name}`
                                                    : `geo-column-${index}`
                                            }
                                            className={
                                                chunkedData.length > 1
                                                    ? 'column'
                                                    : 'one-column'
                                            }
                                        >
                                            <Table data={{ data }} geoTable />
                                        </div>
                                    ))}
                                </div>

                                <div className="geo-card-footer">
                                    <div className="date">As of {asOfDate}</div>
                                </div>
                            </React.Fragment>
                        );
                    }}
                </GqlQueryWrapper>
            </Card>
            <style jsx>{styles}</style>
        </div>
    );
};

export default GeographicalExposureChart;
